import { createAction } from 'redux-actions-helpers'
import { UserType } from './types'
import { CourseType } from '../CoursePage/types'

export const fetchUser = createAction(
  '@@admin-user/FETCH_USER',
  (id: string): any => ({ id })
)

export const fetchUserSuccess = createAction(
  '@@admin-user/FETCH_USER_SUCCESS',
  (result: UserType): any => ({ result })
)

export const fetchUserFailure = createAction(
  '@@admin-user/FETCH_USER_FAILURE',
  (error: string): any => ({ error })
)

export const fetchUserStat = createAction(
  '@@admin-user/FETCH_USER_STAT',
  (id: string): any => ({ id })
)

export const fetchUserStatSuccess = createAction(
  '@@admin-user/FETCH_USER_STAT_SUCCESS',
  (result: CourseType[]): any => ({ result })
)

export const fetchUserStatFailure = createAction(
  '@@admin-user/FETCH_USER_STAT_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-user/DESTROY')
